import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    CALL: 'call',
    PUSH: 'push',
    SMS: 'sms',
    TOTP: 'token:software:totp'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
